import { TableHeader } from '@/coreDomainsModule/table';
/*
i18n用、IBusinessのkeyに対する日本語を格納したもの
各テーブルによって、読み替えが発生する場合、
それに対応したオブジェクトを作成、エクスポートすることにより読み替える
*/

const businessContent: TableHeader = {
  expansion: '展開',
  choice: '選択',
  salesStatus: 'ステータス',
  edit: '編集',
  businessId: 'ID',
  fixOrderDate: '確定発注日',
  endUser: 'エンドユーザー',
  salesDestinationName: '送り先名',
  supplierName: '仕入先名',
  deliveryDestinationName: '納入先',
  businessName: '商品名',
  businessNumber: '商品CD',
  note: '商品詳細',
  unit: '単位',
  form: '荷姿',
  leadTime: 'リードタイム',
  MOQ: '最小発注単位',
  stdInventoryIndex: '標準在庫指数',
  orderAmount: '発注数量',
  deliveryDate: '希望納期',
  inventory: '現在庫数',
  customerName: '売上先名',
  package: '容量',
  manufacture: '製造社',
  warehouse: '置場名',
  subcontractor: '外注先',
  secondSubcontractor: '外注先の外注先',
  sellInventory: '',
  arrivalAndsSalesResults: '入荷販売実績',
  arrivals: '入荷',
  salesResults: '販売実績',
  orderStatus: '発注ステータス',
  supplierForecastStatus: '仕入先内示ステータス',
  orderDate: '確定発注日', // TODO: 発注日のはずでは？
  executionDate: '在庫年月日',
} as const;

const extraHeader = {
  po: '発注書出力',
  orderConfirmation: '発注詳細(ヘッダー)',
  recommendedOrderDate: '発注日(ヘッダー)',
  recommendedOrderAmount: '発注量',
  recommendedDeliveryTime: '希望納期',
  confirmSupplier: '数量確認',
  forecastDetail: '内示詳細',
  saleQuantity: '販売実績',
  businessDetail: '',
  businessNumberNamedByUser: 'ユーザー設定商品CD',
  senderName: '連携依頼送付社',
  userName: '担当者',
  progressRate: '更新率',
  totalBusinessCount: '総件数',
  updatedBusinessCount: '内示更新数',
  latestUpdateAt: '最終更新日時',
} as const;

export const businessContentName = { ...businessContent, ...extraHeader };

/**
 * 上記のようにリファクタを行ったが、デグレが怖いので、残してます
 * テーブル側で上記で問題なさそうであればコメント削除お願いします
 */
// const businessContentName = {
//   expansion: '展開',
//   choice: '選択',
//   salesStatus: 'ステータス',
//   po: '発注書出力',
//   edit: '編集',
//   businessId: 'ID',
//   orderConfirmation: '発注確認',
//   fixOrderDate: '確定発注日',
//   recommendedOrderDate: '推奨発注日',
//   recommendedDeliveryTime: '推奨納期',
//   endUser: 'エンドユーザー',
//   salesDestinationName: '販売先',
//   supplierName: '仕入先',
//   deliveryDestinationName: '納入先',
//   businessName: '商品名',
//   note: '商品詳細',
//   unit: '単位',
//   form: '荷姿',
//   leadTime: 'リードタイム',
//   MOQ: '最小発注単位',
//   stdInventoryIndex: '標準在庫指数',
//   orderAmount: '数量',
//   deliveryDate: '希望納期',
//   confirmSupplier: '数量確認',
//   inventory: '当日在庫',
//   forecastDetail: '内示詳細',
//   saleQuantity: '販売実績',
//   customerName: '売上先',
//   businessNumber: -1,
//   package: '容量',
//   manufacture: '製造社',
//   warehouse: '倉庫',
//   businessDetail: '',
//   subcontractor: '外注先',
//   secondSubcontractor: '外注先の外注先',
//   sellInventory: '',
//   businessNumberNamedByUser: '品番',
//   senderName: '連携依頼送付社',
// };
